import { render, staticRenderFns } from "./ClaimsHistory.vue?vue&type=template&id=1e77381e&scoped=true&"
import script from "./ClaimsHistory.vue?vue&type=script&lang=js&"
export * from "./ClaimsHistory.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsHistory.vue?vue&type=style&index=0&id=1e77381e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e77381e",
  null
  
)

export default component.exports